// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__w1YfU","text":"style_text__3y6dm","children":"style_children__2U2Cb"};